import { useTranslation } from 'react-i18next';
import type { TdsDeclaration } from '../../api/types';
import { StatusPill } from '../ui/StatusPill';
import { StatusIcon } from '../ui/StatusIcon';
import { formatIstDayMon } from '../../features/payments/paymentDates';

/**
 * TDS 194C declaration of a fleet manager (Contract C7), display only: no TDS amount is shown or
 * computed here. A missing field renders nothing — the console can't claim either way.
 */
export function TdsDeclarationPill({ declaration }: { declaration?: TdsDeclaration | null }) {
  const { t } = useTranslation();
  if (!declaration) return null;
  if (declaration.declared) {
    return (
      <StatusPill
        bg="var(--status-green-bg)"
        text="var(--status-green-text)"
        icon={<StatusIcon name="check" />}
        label={`${t('domain.tdsDeclarationPill.declared')}${
          declaration.declaredAt ? ` · ${formatIstDayMon(declaration.declaredAt)}` : ''
        }`}
      />
    );
  }
  return (
    <StatusPill
      bg="var(--status-gray-bg)"
      text="var(--status-gray-text)"
      icon={<StatusIcon name="hourglass" />}
      label={t('domain.tdsDeclarationPill.none')}
    />
  );
}
